var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_button)?_c('button',_vm._b({attrs:{"id":"google-pay-btn","title":"Google Pay"},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},'button',_vm.ADAattr('label', 'Pay with Google Pay'),false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }